import React from "react"
import Konva from "./components/Konva.js"
import 'bootstrap/dist/css/bootstrap.min.css'
import { KonvaProvider } from "./context/KonvaContext.js"

function App() {
  return (
    <KonvaProvider>
      <div className="App">
        <Konva />
      </div>
    </KonvaProvider>
  )
}

export default App
